module.exports = __webpack_public_path__ + "static/9-insights-2-7e0fe9f9940183a98a69f0ca39e9caa0.jpg";